import { NgModule } from "@angular/core";
import { VDateComponent } from "./v-date.component";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports:      [CommonModule, FontAwesomeModule],
    exports:      [VDateComponent],
    declarations: [VDateComponent]
})
export class VDateModule {}